module.exports = __webpack_public_path__ + "img/abacus_type_5 (old).005a224b.png";